import React, { ReactElement, useState } from 'react';
import ReactDOM from 'react-dom';
import { GOOGLE_DEVELOPER_KEY } from '../../utils/constants';
import { cloudinaryTransform } from '../../utils/cloudinaryTransformations';

interface SellerData {
  latitude: number;
  longitude: number;
  locationPhoto?: string;
}

interface Props {
  sellerLocationData: SellerData;
}

const SeeLocation: React.FC<Props> = ({
  sellerLocationData,
}) => {
  const center = [Number(sellerLocationData.latitude), Number(sellerLocationData.longitude)];
  const [isOpened, setIsOpened] = useState(false);

  const generateLinkUrl = (latLon: number[] = [41.0, -77.5]): string => {
    const blurredLocation = `${latLon[0].toFixed(1)},${latLon[1].toFixed(1)}`;
    return `https://www.google.com/maps/search/?api=1&query=${blurredLocation}`;
  };

  const generateMapUrl = (latLon: number[] = [41.0, -77.5], aspect = 'wide'): string => {
    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap?';
    const blurredLocation = `${latLon[0].toFixed(1)},${latLon[1].toFixed(1)}`;
    const markerQueryParams = ['color:0x3e5c76', blurredLocation];
    const staticMapQueryParams = [
      `center=${blurredLocation}`,
      `key=${GOOGLE_DEVELOPER_KEY}`,
      `markers=${markerQueryParams.join('%7C')}`,
      aspect === 'wide' ? 'size=600x350' : 'size=350x350',
      'zoom=10',
    ];
    return baseUrl + staticMapQueryParams.join('&');
  };

  const locationPhotoBackgroundUrl = (): string => {
    if (sellerLocationData.locationPhoto) {
      return cloudinaryTransform(sellerLocationData.locationPhoto, ['w_350,h_350,c_fill']);
    }
    return 'https://via.placeholder.com/350x350.png?text=No+Location+Photo';
  };

  const VisualizeLocation: React.FC = (): ReactElement => {
    return (
      <div className="seller-location-photo-and-map">
        <a href={generateLinkUrl(center)} target="_blank" rel="noreferrer" className="seller-location-map">
          <img
            src={generateMapUrl(center, 'square')}
            alt="Map showing seller's approximate location"
            className="seller-location-map img-fluid"
            title="Seller's Approximate Location"
          />
        </a>
        <div
          className="seller-location-photo"
          style={{ backgroundImage: `url(${locationPhotoBackgroundUrl()})` }}
        />
      </div>
    );
  };

  const toggle = (): void => {
    setIsOpened((wasOpened) => !wasOpened);
  };

  return (
    <div className="col-xs-12">
      <button className="btn btn-block see_location-btn mt-2 border border-solid" onClick={toggle}>
        {!isOpened ? (
          <>
            See Location
            {' '}
            <i className="fa fa-angle-down ml-2" />
          </>
        ) : (
          <>
            Hide Location
            {' '}
            <i className="fa fa-angle-up ml-2" />
          </>
        )}
      </button>
      {isOpened && <VisualizeLocation />}
    </div>
  );
};

const elements = document.getElementsByClassName('react-see-location');
if (elements.length > 0) {
  Array.from(elements).forEach((element) => {
    const sellerLocationData = JSON.parse(element.getAttribute('data-seller-location') || '{}');
    ReactDOM.render(<SeeLocation sellerLocationData={sellerLocationData} />, element);
  });
}

export default SeeLocation;
